import { useContext } from 'react';
import { ProjectContext } from '../context';

export function useProjects() {
  const context = useContext(ProjectContext);
  return { ...context };
}
